import * as actionType from './types';
import axios from '../../../common/config/axios';

export const getList = (props) => dispatch => {
  axios.get('transaction/list', {params: props})
  .then(function (response) {
    dispatch ({
      type: actionType.TRANSACTION_LIST,
      value: response.data
    });
  })
  .catch(err => {
    
  });
};

export const cancelWithdraw = (data) => dispatch => {
  axios.post('transaction/cancel', data)
  .then(function (response) {
    dispatch ({
      type: actionType.TRANSACTION_CANCEL,
      value: response.data
    });
  })
  .catch(err => {
    
  });
};

export const getDropdown = () => dispatch => {
  axios.get('transaction/dropdown')
  .then((res) => {
    dispatch({
      type: actionType.TRANSACTION_DROPDOWN,
      value: res.data
    });
  })
  .catch((err) => {

  });
}